import { SidebarModal } from '@domain-group/suit-theme'

import EntityActivity from '@components/EntityActivity'

import type { UseOrderItemPayload } from '@hooks/useOrderItem'

interface OrderItemActivityProps {
  orderItemPayload: UseOrderItemPayload,
}

const OrderItemActivity = (props: OrderItemActivityProps) => {
  const {
    orderItemPayload: {
      orderItem,
    },
  } = props

  return (
    <SidebarModal.ExpandableSection
      label="Order Item Activity"
      title="View Activity"
      style={{ marginTop: 16 }}
    >
      <EntityActivity.Activity
        boxProps={{
          marginTop: 0,
        }}
        requestOptions={EntityActivity.requestOptions.activity}
        subjectId={orderItem.id}
        subjectType="OrderItem"
      />
    </SidebarModal.ExpandableSection>
  )
}

export default OrderItemActivity
